import { LinkTo } from "@ember/routing";
import { pageTitle } from "ember-page-title";
import AutoRouteNav from "#components/auto-route-nav.gts";

<template>
  {{pageTitle "Component Sandbox"}}
  <div class="min-h-screen bg-slate-950 text-slate-100 p-8">
    <header class="mb-4 border-b border-slate-800 pb-2 space-y-4">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 class="text-2xl font-bold tracking-tight text-white flex items-center gap-3">
            Sandbox

          </h1>
          <p class="text-slate-400 text-sm mt-1">
            Interactive isolated component testing harness for Ember Beats Redux.
          </p>
        </div>
      </div>

      <div class="flex items-center gap-2 pt-2 border-t border-slate-800/60 overflow-x-auto">
        <span>Sandboxes:</span>
        <AutoRouteNav @id="sandbox" class="flex items-center gap-2" as |ar|>
          <LinkTo
            @route={{ar.name}}
            class="text-yellow-600 underline hover:text-yellow-800 [&.active]:no-underline"
          >
            {{ar.title}}
          </LinkTo>
        </AutoRouteNav>
      </div>
    </header>

    <main>
      {{outlet}}
    </main>
  </div>
</template>
